import { thunk } from 'easy-peasy';
import api from '~/services/api';
import { IThunkUpdateExemption } from '../types';

const onUpdateExemption: IThunkUpdateExemption = thunk(
  async (_, { exemptionId, exemption, ...client }) => {
    await api.communityEngagement.updateExemption(client, exemptionId, exemption);
  },
);

export default onUpdateExemption;
